import { Link, useParams } from "react-router-dom";
import { useGetTeamMemberByIdQuery } from '../../../../reactQueries/AppApi/rqHooksForAccountTeamMembers';
import EditAccountTeamMembers from "./EditAccountTeamMembers";
import MpgErrorDialog from "../../../../common/dialog/MpgErrorDialog";

const EditAccountTeamMembersHome = () => {
    let { Id } = useParams();

    /**API calls */
    const { isSuccess, isFetching, error, data: teamMemberDataById, isError, isLoading, } = useGetTeamMemberByIdQuery({ staffId: Id });

    return (
        <div>
            {
                (!!isFetching) && "Wait, Loading...."
            }
            {
                !!isSuccess && (<EditAccountTeamMembers
                    teamMemberDataById={teamMemberDataById}
                />)
            }
            <MpgErrorDialog
                open={isError}
            />
        </div>
    )


}
export default EditAccountTeamMembersHome